export default __webpack_public_path__ + "static/media/promo-global.494164e3.png";